import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

/* eslint-disable max-len */
const LinkedIn: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1.13929 0H14.8571C15.4857 0 16 0.517857 16 1.15357V14.8464C16 15.4821 15.4857 16 14.8571 16H1.13929C0.510714 16 0 15.4821 0 14.8464V1.15357C0 0.517857 0.510714 0 1.13929 0ZM4.83929 13.7143V6.07857H2.46429V13.7143H4.83929ZM3.65 5.03571C2.88929 5.03571 2.275 4.41786 2.275 3.66071C2.275 2.90357 2.88929 2.28571 3.65 2.28571C4.40714 2.28571 5.025 2.90357 5.025 3.66071C5.025 4.42143 4.41071 5.03571 3.65 5.03571ZM11.3536 13.7143H13.725V9.52857C13.725 7.47143 13.2786 5.88929 10.8786 5.88929C9.725 5.88929 8.95 6.52143 8.63214 7.12143H8.6V6.07857H6.325V13.7143H8.69643V9.93571C8.69643 8.93929 8.88571 7.975 10.1214 7.975C11.3357 7.975 11.3536 9.11429 11.3536 10V13.7143Z'
				fill='#007BB5'
			/>
		</Svg>
	);
};

export { LinkedIn };
